/**
 * The reference assistant's framework-free entry point: statement and
 * citation-request types, a message's statement-reference state, and the
 * predicates the chat uses to decide which bubbles to draw. Nothing here
 * loads React, the query client or the HTTP client, so the chat's pure
 * render planning can import it without dragging the adapter in.
 */
export type {
  AttachedStatementReference,
  ExtractedStatement,
  StatementCitationStatus,
  StatementReferenceHelpRequest,
} from './extractedStatements';

export {
  hasApprovedExtractedStatements,
  shouldShowAddReferencesPrompt,
  type StatementReferenceState,
} from './statementReferenceState';

export type { CitationRequestStatus } from './citationRequest';

export type { StatementTriageEntryMode, StatementTriageOpenSource } from './statementTriage';

export { computeReferenceNumbering } from './numbering';

export { REFERENCE_ASSISTANT_INTRO_COPY } from './introCopy';
